import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Tablet = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <>
        <path
          d='M3.75 4A2.25 2.25 0 0 1 6 1.75h12A2.25 2.25 0 0 1 20.25 4v16A2.25 2.25 0 0 1 18 22.25H6A2.25 2.25 0 0 1 3.75 20z'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
        />
        <path
          d='M9 19H15'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
        />
      </>
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M6 1a3 3 0 0 0-3 3v16a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V4a3 3 0 0 0-3-3zm3 17.25a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
